export const CACHE_VALUE_TO_REFETCH = 2; // 0 = from db, 1 = from clean cache, 2 = from dirty cache
export const TIME_TO_REFETCH = 5000; // 5 seconds
